module.exports = __webpack_public_path__ + "actor4.png?74ed124ac33b2096b2db6183cf2bcf55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/actor4.png
// module id = 60
// module chunks = 0